import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/icons/finalogo.png";

const Header = () => {
  return (
    <header className="fixed top-0 left-0 w-full bg-white shadow-md z-50">
      <div className="container mx-auto flex items-center justify-between py-3 px-6">
        {/* Logo */}
        <div className="flex items-center h-20 w-44">
          <Link to="/">
            <img src={logo} alt="Logo" className=" p-0 m-0" />
          </Link>
        </div>

        {/* Navigation */}
        <nav>
          <ul className="flex space-x-6 text-black font-medium">
            <li className="cursor-pointer hover:text-blue-600 transition">
              <Link to="/">Home</Link>
            </li>

            <NavItem title="Workforce Solutions">
              <DropdownMenu
                items={["Staffing", "Payroll Services", "Consulting"]}
              />
            </NavItem>

            <NavItem title="Industries">
              <DropdownMenu
                items={[
                  "Information Technology and Non-IT",
                  "Healthcare/Pharma",
                  "Engineering",
                  "Telecom",
                  "Banking, Financial Services, Insurance (BFSI)",
                  "Manufacturing and Supply Chain",
                  "Retail and E-Commerce",
                ]}
              />
            </NavItem>

            <li className="cursor-pointer hover:text-blue-600 transition">
              <Link to="/contact">Contact Us</Link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

// Reusable Navigation Item Component
const NavItem = ({ title, children }) => {
  const [open, setOpen] = useState(false);

  return (
    <li
      className="relative cursor-pointer hover:text-blue-600 transition"
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      {title} <span className="ml-1">▼</span>
      {open && children}
    </li>
  );
};

// Dropdown Menu Component
const DropdownMenu = ({ items }) => {
  return (
    <ul className="absolute left-0 top-full mt-2 w-48 bg-white shadow-lg rounded-lg py-2">
      {items.map((item, index) => (
        <li
          key={index}
          className="px-4 py-2 hover:bg-gray-100 cursor-pointer transition"
        >
          {item}
        </li>
      ))}
    </ul>
  );
};

export default Header;
